"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SLC_FA_HOW_FLEX_WORKS = exports.SLC_CLASSIC_HOW_FLEX_WORKS = void 0;
var CLASSIC_BULLETS = [
    {
        HEADER: 'You pay a {{deposit}} deposit to Flex',
        BODY: 'This deposit unlocks your secured line of credit, which we use to pay rent.'
    },
    {
        HEADER: 'Flex pays your {{rent}} rent',
        BODY: 'Once you’ve made your deposit, we pay your rent directly to your property when it’s due.'
    },
    {
        HEADER: 'You pay {{baseAmount}} to Flex',
        BODY: 'You’ll make a payment for the remaining {{baseAmount}} later in the month. We collect your deposit automatically to settle the rest of your balance.'
    },
    {
        HEADER: 'Repeat each month',
        BODY: 'Your payment schedule will recur month-to-month. You can manage your plan in the app.'
    },
];
var FA_BULLETS = CLASSIC_BULLETS.map(function (bullet, i) {
    return i === 1
        ? {
            HEADER: 'Flex helps pay your {{rent}} rent',
            BODY: 'Once you’ve made your deposit, use your Flex-provided {{paymentMethod}} to pay rent in your rent portal.'
        }
        : bullet;
});
var HEADING = 'How does Flex split my rent?';
var SUBTITLE = 'With Flexible Rent, you have a {{rent}} secured line of credit equal to your full rent amount. ';
var CTA = 'Done';
exports.SLC_CLASSIC_HOW_FLEX_WORKS = {
    HEADING: HEADING,
    SUBTITLE: SUBTITLE,
    CTA: CTA,
    BULLETS: CLASSIC_BULLETS
};
exports.SLC_FA_HOW_FLEX_WORKS = __assign(__assign({}, exports.SLC_CLASSIC_HOW_FLEX_WORKS), { BULLETS: FA_BULLETS });
